import { viewModelBase } from "../../view-model-base";
import { LaeLibraryConstraintDataModel } from "./lae-library-constraint-data.model";

export class ConstraintFilterModel {
    laeLibraryCollectionDataModels: LaeLibraryConstraintDataModel[] = [];
    selectedLibraryCollectionId: string = '';
    displayCurrentOperatingPoint: boolean = false;
    sortOption: string = '';
    orderBy: string = '';
}

